import { render } from "./App.vue?vue&type=template&id=22246a98"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=22246a98&lang=css"

import exportComponent from "C:\\Entwicklung\\werbeo-app-private\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__